import type { IContentBase } from "@/types/content";
import { useMutationState } from "@tanstack/vue-query";

export function useContentUpdateMutation() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (payload: Pick<IContentBase, "id"> & Partial<IContentBase>) => {
      const { data } = await usePutRequest<IContentBase>("/content", payload);
      return data;
    },
    mutationKey: ["content-update"],
    onSuccess(data) {
      if (!data) return;
      updateSingleContentInQueryCache(data.id, data, queryClient);
      if (data.taskId) {
        updateSingleContentListQueryCache(data.taskId, data, queryClient);
      }
    },
  });

  return mutation;
}

export function useContentUpdateList() {
  const variables = useMutationState<string>({
    filters: {
      mutationKey: ["content-update"],
      status: "pending",
    },
    select: mutation => {
      const payload = mutation.state.variables as Pick<IContentBase, "id"> &
        Partial<IContentBase>;
      return payload?.id || "";
    },
  });

  return variables;
}
